import type { FC } from 'react';

import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData, graphql } from '@packages/gql/generated/shopping';

import type { ProductGridLoaderProps } from './ProductGridLoader';
import {
  CategoryPageProductGridLoader,
  SearchResultPageProductGridLoader,
} from './ProductGridLoader';
import { ensureExhaustiveCases } from '../../utils/ensureExhaustiveCases';

export const ProductGridLoaderSwitchFragment = graphql(/* GraphQL */ `
  fragment ProductGridLoaderSwitchFragment on SearchProductResult {
    __typename
  }
`);

export type ProductGridLoaderSwitchProps = ProductGridLoaderProps & {
  maskedResult: FragmentType<typeof ProductGridLoaderSwitchFragment>;
};

export const ProductGridLoaderSwitch: FC<ProductGridLoaderSwitchProps> = ({
  maskedResult,
  ...dynamicProductGridProps
}) => {
  const result = getFragmentData(ProductGridLoaderSwitchFragment, maskedResult);

  switch (result.__typename) {
    case 'SuccessfulSearchResult':
      return <SearchResultPageProductGridLoader {...dynamicProductGridProps} />;
    case 'CategoryResult':
      return <CategoryPageProductGridLoader {...dynamicProductGridProps} />;
    default:
      return ensureExhaustiveCases(result);
  }
};
